import { CHANGE_BORDER_COLOR, CHANGE_BORDER_TYPE } from '../../constants/projectActions'

export const changeColor = color => ({ type: CHANGE_BORDER_COLOR, color })
export const changeBorder = (borderType, borderWidth, color, label) => ({ type: CHANGE_BORDER_TYPE, borderType, borderWidth, color, label })



// WEBPACK FOOTER //
// ./src/actions/project/border.js